import axios from "axios";
import {
  Box,
  Button,
  Drawer,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Tabs,
  Tab,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";
import { useHistory } from "react-router-dom";
import { loadAlert } from "redux/reducers/top";
import { useDispatch, useSelector } from "react-redux";
import { Cookies } from "react-cookie";
import { rem } from "assets/js/common";
import InfiniteScroll from "react-infinite-scroll-component";

const cookies = new Cookies();

export default function CategoryItems(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { drawerOpen, handleDrawerOpen, handleDrawerClose } = props;
  const [productList, setProductList] = useState({ list: [] });
  const [tabVal, setTabVal] = useState("");
  const [category, setCategory] = useState([]);
  const [sordFld, setSordFld] = useState("catgSort");
  const [token, setToken] = useState("");
  const [rows, setRows] = useState([]);
  const [initialized, setInitialized] = useState(true);
  const [pg, setPg] = useState(1);

  let favInfo = cookies.get("favInfo");

  const [drawerData, setDrawerData] = useState("catgSort");

  useEffect(() => {
    setToken(cookies.get("X-AUTH-TOKEN"));
    // loadCategory();
    // loadList();
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) {
      setToken(cookies.get("X-AUTH-TOKEN"));
      loadCategory();
    }
  }, [init]);

  const loadList = (type) => {
    axios
      .get(`/api/eh/product/category`, {
        params: {
          schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
          schCd: tabVal,
          sordFld: drawerData,
          pg: pg,
          pgSz: 10,
        },
      })
      .then((res) => {
        // let newList = [];
        let newList = res.data.data.productList;
        if (newList) {
          if (!type && pg > 1) {
            setRows({
              ...newList,
              list: [...productList.list, ...newList.list],
            });
          } else {
            setRows({ ...newList });
          }
        }
      });

    // if (type) setPg(1);
    // else setPg(pg + 1);
  };

  const loadCategory = () => {
    console.log("favInfo && favInfo.visibleTp", favInfo && favInfo.visibleTp);
    axios
      .get(
        `/api/st/code/use-list/${
          favInfo && favInfo.visibleTp === "1" ? "PR" : "PB"
        }`
      )
      .then((res) => {
        if(res.data.data.codeList.length > 0) {
          setCategory(res.data.data.codeList);
          setTabVal(res.data.data.codeList[0].cd);
          // loadList(res.data.data.codeList[0].cd);
        }
      });
  };

  const handleFav = (item) => {
    axios
      .post("/api/eh/product/favorite/fav", {
        seq: item.seq,
      })
      .then((res) => {
        setPg(1);
        loadList();
        console.log("item", item);
      });
  };

  useEffect(() => {
    if (drawerOpen === true) setDrawerData(sordFld);
  }, [drawerOpen]);

  const handleInfiniteScroll = () => {
    if (pg > rows.totalPageSize) {
      setInitialized(false);
      return;
    }

    setPg(pg + 1);
    loadList();
  };

  useEffect(() => {
    loadList(tabVal, "changeTp");
  }, [tabVal]);

  useEffect(() => {
    setProductList({ ...rows });
  }, [rows]);

  return (
    <div className="categoryItems">
      <div className="header">
        <Tabs
          value={tabVal}
          onChange={(e, val) => {
            console.log("val: ", val);
            setTabVal(val);
            setPg(1);
          }}
          variant="scrollable"
          scrollButtons="auto"
          style={{ marginTop: rem(-5) }}
        >
          {/* <Tab key={999} label="전체" value="" /> */}
          {category &&
            category.map((item, i) => (
              <Tab key={i} label={item.nm} value={item.cd} />
            ))}
        </Tabs>
        <div className="func-wrap">
          <div className="cnt">총 {rows.totalSize}개</div>
          <div className="sort">
            <Button
              onClick={handleDrawerOpen}
              className="fontN"
              style={{ fontSize: rem(13) }}
            >
              {sordFld === "catgSort"
                ? "추천 순"
                : sordFld === "rgst"
                ? "최신 등록 순"
                : sordFld === "amtAsc"
                ? "가격 낮은 순"
                : "가격 높은 순"}
              <KeyboardArrowDownTwoToneIcon />
            </Button>
          </div>
        </div>
        <div className="divider" />
      </div>
      <Grid contianer className="list-wrap">
        {rows && rows.list && (
          <InfiniteScroll
            dataLength={rows.list.length}
            next={handleInfiniteScroll}
            hasMore={setInitialized}
            inverse={false}
          >
            {rows.list.map((item, i) => (
              <Grid
                item
                key={i}
                className="item"
                onClick={() => {
                  history.push({
                    pathname: `/product-of-week/detail/${item.seq}`,
                    props: {
                      seq: item.seq,
                    },
                  });
                }}
              >
                <div className="item-img">
                  <div className="img-wrap">
                    <img src={item.prodImgUrl} />
                  </div>
                  {item.dcMak && (
                    <div className="badge">
                      <div className="txt">{item.dcMak}</div>
                    </div>
                  )}
                </div>
                <div className="contents-wrap">
                  <div className="tit">{item.ttl}</div>
                  {item.prchTrms && (
                    <div className="sub-tit">{item.prchTrms}</div>
                  )}
                  <div className="price">
                    {item.prc.toLocaleString()}
                    <span>원</span>
                  </div>
                  {item.dcTp && <div className="grey-box">{item.dcTp}</div>}
                  {item.prmtCont && (
                    <div className="red-box">{item.prmtCont}</div>
                  )}
                  {item.qty && (
                    <div className="cnt">
                      한정수량 {item.qty.toLocaleString()}개
                    </div>
                  )}
                  <div className="func-btn">
                    <Button
                      className="fav"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (token) handleFav(item, i);
                        else dispatch(loadAlert(true));
                      }}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/icon/favorite${
                          item.favYn == "Y" ? "" : "-off-d"
                        }.svg`}
                        style={{ width: rem(24), height: rem(24) }}
                      />
                      <span
                        style={{
                          color: item.favYn == "Y" ? "#F1270B" : "#bebebe",
                        }}
                      >
                        {item.favCnt}
                      </span>
                    </Button>
                  </div>
                </div>
              </Grid>
            ))}
          </InfiniteScroll>
        )}
      </Grid>

      {/* ST : Drawer-row */}
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={handleDrawerClose}
        className="drawer-common-bottom size-small"
      >
        <div className="drawer-head">
          <h3>정렬 기준</h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={handleDrawerClose}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box className="box-type-10">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={drawerData}
              value={drawerData}
              name="radio-buttons-group"
              onChange={(e) => {
                setDrawerData(e.target.value);
              }}
            >
              <FormControlLabel
                value="catgSort"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="추천 순"
              />
              <FormControlLabel
                value="rgst"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="최신 등록 순"
              />
              <FormControlLabel
                value="amtAsc"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="가격 낮은 순"
              />
              <FormControlLabel
                value="amtDesc"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="가격 높은 순"
              />
            </RadioGroup>
          </Box>
        </div>
        <div className="drawer-foot">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setSordFld(drawerData);
              setPg(1);
              loadList();
              handleDrawerClose();
            }}
          >
            선택완료
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-row */}
    </div>
  );
}
